import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from "react-select";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import InputField from "../../utils/InputField";
import ConfirmPasswordFields from "../../utils/ConfirmPasswordFields";
import StaticFunctions from "../../utils/StaticFunctions";
import Timeformat from "../../utils/Timeformat";
import CheckBoxField from "../../utils/CheckBoxField";
import InputDatePicker from "../../utils/InputDatePicker";

import "../../css/style-table.css";

class UserEditContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    static defaultProps = {
        rights: [],
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.initValidUntil = new Date();
        this.initValidUntil.setFullYear(this.initValidUntil.getFullYear() + 1);

        this.state = {
            companies: [],
            inputError: [],
            inputParams: {
                id: '',
                companyId: '',
                email: '',
                firstName: '',
                lastName: '',
                lastSeen: '',
                rights: [],
                language: '',
                dateValidUntil: this.initValidUntil,
                dateDeleted: '',
                password: '',
                accountLock: '',
            },
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.hiddenUserRights = ['superadmin', 'zskadmin', 'admin', 'ps_login', 'ps_puncher', 'designshop_login', 'designshop_vendor'];

        this.defaultLock = 0;

        this.requestUserDetails = this.requestUserDetails.bind(this);
        this.requestCompaniesForUser = this.requestCompaniesForUser.bind(this);
        this.saveEditUserDetails = this.saveEditUserDetails.bind(this);
        this.setInputError = this.setInputError.bind(this);
        this.resetInputError = this.resetInputError.bind(this);
        this.getInput = this.getInput.bind(this);
        this.setValidUntil = this.setValidUntil.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);

    }

    componentWillMount() {

        this.requestUserDetails();
        this.requestCompaniesForUser();

    }

    requestUserDetails() {

        const params = {
            action: 'getUserDetails',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.user.id
        };

        const callback = function(res) {
            if (res) {
                const userRights = (res.rights) ? this.getSplittedUserRights(res.rights) : [];

                this.defaultLock = res.account_lock;

                this.setState({
                    inputParams: {
                        id: res.id,
                        companyId: res.id_company,
                        email: res.email,
                        firstName: res.first_name,
                        lastName: res.last_name,
                        lastSeen: res.last_seen,
                        rights: userRights,
                        password: '',
                        language: res.language,
                        dateValidUntil: (res.valid_until) ? new Date(parseInt(res.valid_until)) : this.initValidUntil,
                        dateDeleted: res.date_deleted,
                        accountLock: res.account_lock,
                    },
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestCompaniesForUser() {

        if (this.props.baseData.checkUserRole('superadmin')) {
            const opts = StaticFunctions.getSelectOptionsFromArray(this.props.baseData.companies.companies, 'id', 'label');

            this.setState({
                companies: opts
            });
        } else {
            const params = {
                action: 'getCompaniesForUser',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                companyId: this.props.user.id_company,
                userId: this.props.baseData.userData.id
            };

            const callback = function (res) {
                if (res) {
                    this.setState({
                        companies: res
                    });
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    enterSaveEditUserDetails(event) {

        if (event.keyCode === 13) {
            this.saveEditUserDetails();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    saveEditUserDetails() {

        const params = {
            action: 'saveUserDetails',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            userId: this.state.inputParams.id,
            email: this.state.inputParams.email,
            firstName: this.state.inputParams.firstName,
            lastName: this.state.inputParams.lastName,
            companyId: this.state.inputParams.companyId,
            language: this.state.inputParams.language,
            dateValidUntil: (this.state.inputParams.dateValidUntil) ? this.state.inputParams.dateValidUntil.getTime() : this.initValidUntil,
            dateDeleted: this.state.inputParams.dateDeleted,
            accountLock: this.state.inputParams.accountLock,
            password: this.state.inputParams.password,
            rights: this.state.inputParams.rights,
        };

        const callback = function(res) {
            if (res.success) {
                alert(this.translate(res.msgKey));

                this.props.changeView();
            } else {
                this.setInputError(res.errors);
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    getSplittedUserRights(rights) {

        const splittedRights = rights.split(';');

        return splittedRights.filter(
            (right) => {
                return !this.hiddenUserRights.includes(right);
            }
        );

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    setValidUntil(date) {

        this.getInput(null, 'dateValidUntil', date, true);

    }

    moveCursorToEnd(field) {

        const temp_value = field.target.value;

        field.target.value = '';
        field.target.value = temp_value;

    }

    editRightBox(event, key) {

        const newInput = {...this.state.inputParams};
        const checked = event.target.checked;

        if (checked) {
            newInput.rights.push(key);
        } else {
            newInput.rights = newInput.rights.filter((right) => right !== key);
        }

        this.setState({
            inputParams: newInput
        });

    }

    userLockHandle(event, value) {

        const newInput = {...this.state.inputParams};

        if (newInput) {
            newInput.accountLock = value;

            this.setState({
                inputParams: newInput
            });
        }

    }

    editSelect(event, key) {

        const newInput = {...this.state.inputParams};

        newInput[key] = event.value;

        this.setState({
            inputParams: newInput
        });

    }

    toggleCheckBox(fieldName, isChecked) {

        const newInput = {...this.state.inputParams};

        if (isChecked) {
            newInput.rights.push(fieldName);
        } else {
            newInput.rights = newInput.rights.filter((right) => right !== fieldName);
        }

        this.setState({
            inputParams: newInput
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    renderRights() {

        const rights = this.props.rights;
        const doNotShow = this.hiddenUserRights;
        const userRights = (this.state.inputParams) ? this.state.inputParams.rights : [];

        if (!this.props.baseData.checkUserRole('superadmin')) doNotShow.push('translations');

        return rights.map(
            (right, index) => {
                if (!doNotShow.includes(right.value)) {
                    return (
                        <CheckBoxField
                            key={'right-' + index}
                            name={right.value}
                            label={right.label}
                            isChecked={userRights.includes(right.value)}
                            onChange={this.toggleCheckBox}
                        />
                    );
                }
            }
        );

    }

    render() {

        if (!this.state.inputParams) return <LoadingSplash />;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const companies = StaticFunctions.getSortedData(this.state.companies, 'label', 'string');
        const languages = (this.props.baseData.languages) ? this.props.baseData.languages.languages : [];
        const lastSeen = (this.state.inputParams.lastSeen) ? Timeformat.fromUnix(this.state.inputParams.lastSeen).getFormatedDate(format, timezone) : '-';
        const dateDeleted = (this.state.inputParams.dateDeleted) ? Timeformat.fromUnix(this.state.inputParams.dateDeleted).getFormatedDate(format, timezone) : '-';
        const userLock = this.state.inputParams.accountLock;
        const rightsBlock = this.renderRights();

        const disabledCompanySelection = (companies.length === 1);
        const disabledLanguageSelection = (languages.length === 1);

        const accountUnlockButtonClasses = ['optionActive', (userLock <= 2) ? 'optionOpacity' : ''].join(' '). trim();
        const accountLockButtonClasses = ['optionNotActive', (userLock > 2) ? 'optionOpacity' : ''].join(' '). trim();

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('userSettings')}</h1>
                </nav>

                <div className="col-lg-4">
                    <div className="formRow">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-left labelSpan">{this.translate('id')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="id"
                                            value={this.state.inputParams.id}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('email')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="email"
                                            value={this.state.inputParams.email}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('firstLastName')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="firstName"
                                            className={this.checkInputError('firstName')}
                                            value={this.state.inputParams.firstName}
                                            isRequired={true}
                                            style={{marginRight: 8, width: 126}}
                                            onBlur={this.getInput}
                                        />

                                        <InputField
                                            name="lastName"
                                            className={this.checkInputError('lastName')}
                                            value={this.state.inputParams.lastName}
                                            isRequired={true}
                                            style={{width: 126}}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('company')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="companyId"
                                            className={['chosen-container', 'chosen-container-single', this.checkInputError('companyId')].join(' ').trim()}
                                            style={{width: '260px'}}
                                            options={companies}
                                            value={companies.find(o => String(o.value) === String(this.state.inputParams.companyId)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={false}
                                            noResultsText={this.translate('noResultsFound')}
                                            disabled={disabledCompanySelection}
                                            onChange={(event) => this.editSelect(event, 'companyId')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('language')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="language"
                                            className={['chosen-container', 'chosen-container-single', this.checkInputError('language')].join(' ').trim()}
                                            style={{width: '260px'}}
                                            options={languages}
                                            value={languages.find(o => String(o.value) === String(this.state.inputParams.language)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={false}
                                            noResultsText={this.translate('noResultsFound')}
                                            disabled={disabledLanguageSelection}
                                            onChange={(event) => this.editSelect(event, 'language')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('validUntil')}</td>

                                    <td className="text-left">
                                        <InputDatePicker
                                            name="dateValidUntil"
                                            value={this.state.inputParams.dateValidUntil}
                                            locale={this.props.baseData.userData.language}
                                            onChange={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('deletedOn')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="deletedOn"
                                            value={dateDeleted}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('lastSeen')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="lastSeen"
                                            value={lastSeen}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div>
                        <div className="formBox">
                            <div className="formBoxHeader">
                                {this.translate('rights')}
                            </div>

                            <div>
                                {rightsBlock}
                            </div>
                        </div>

                        <div>
                            <div className="formBox">
                                <div className="formBoxHeader">
                                    {this.translate('other')}
                                </div>

                                <div className="tableContainer" style={{backgroundColor: 'transparent', border: 'none'}}>
                                    <span className="tableOptions" style={{marginRight: 5}}>
                                        <a className={accountLockButtonClasses} onClick={(event) => this.userLockHandle(event, 0)} style={{borderTopRightRadius: 0, borderBottomRightRadius: 0, marginRight: 0}}>&nbsp;</a>
                                        <a className={accountUnlockButtonClasses} onClick={(event) => this.userLockHandle(event, this.defaultLock)} style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}>&nbsp;</a>
                                    </span>

                                    <span>{this.translate('userUnlock')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <nav>
                        <h1>{this.translate('password')}</h1>
                    </nav>

                    <div className="col-lg-4">
                        <ConfirmPasswordFields
                            label1={this.translate('newPassword')}
                            label2={this.translate('confirmPassword')}
                            required={false}
                            onConfirm={this.getInput}
                        />

                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan webElement">&nbsp;</td>

                                        <td className="text-left">
                                            <a className="formButton" onClick={() => this.props.changeView()}>
                                                {this.translate('cancel')}
                                            </a>

                                            <a className="formButton" onClick={() => this.saveEditUserDetails()} onKeyDown={(event) => this.enterSaveEditUserDetails(event)}>
                                                {this.translate('save')}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div>
                            <p>{this.translate('changePasswordNoteText')}</p>
                        </div>

                        <div>
                            <ul>
                                <li>{this.translate('changePasswordNote1')}</li>
                                <li>{this.translate('changePasswordNote2')}</li>
                                <li>{this.translate('changePasswordNote3')}</li>
                                <li>{this.translate('changePasswordNote4')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

export default UserEditContainer;
